import { Injectable, ViewContainerRef } from '@angular/core';
import { ToastsManager, Toast, ToastContainer } from 'ng2-toastr/ng2-toastr';
@Injectable()
export class AlertService {
  constructor(public toastr: ToastsManager) {}

  showSuccess(message: string, title?: string, options?: any): Promise<any> {
    const promise = this.toastr.success(message, title, options);
    return promise;
  }

  showError(message: string, title?: string, options?: any): Promise<any> {
    if (!options) {
      options = {};
    }
    options.enableHTML = true;
    options.toastLife = 600000; // lifetime to 10 min

    const promise = this.toastr.error(message, title, options);
    return promise;
  }

  showWarning(message: string, title?: string, options?: any): Promise<any> {
    const promise = this.toastr.warning(message, title, options);
    return promise;
  }

  showInfo(message: string, title?: string, options?: any): Promise<any> {
    const promise = this.toastr.info(message, title, options);
    return promise;
  }

  showCustom(message: string, title?: string, options?: any): Promise<any> {
    const promise = this.toastr.custom(message, title, options);
    return promise;
  }

  hideWarnings() {
    if (this.toastr.container) {
      const toastContainer = this.toastr.container.instance as ToastContainer;
      for (const t of toastContainer.toasts) {
        if (t.type === 'warning') {
          this.toastr.clearToast(t);
        }
      }
    }
  }

  hideAlert(alert) {
    this.toastr.clearToast(alert);
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/alert.service.ts